import { useHasuraClaim } from '@nhost/react'

export const useSellerMemberId = () => {
  const id = useHasuraClaim('seller-member-id')
  if (!id) return undefined
  return id as string
}
